<template>
    <div class="print">

    <el-button size="PrintTheContract"
               round
               @click="PrintTheContract">打印合同</el-button>
    <div id="print">
      <h4> 深圳云上初阳电子商务有限公司</h4>
      <h4>PCB订货合同</h4>
      <h5> 甲方（需求方）：</h5>
      <h5> 乙方（供应商）： 深圳云上初阳电子商务有限公司</h5>
      <h5> 合同生成日期：{{time}}</h5>
      <h5>合同生成前支付状态：{{Ord_CheckResult}}</h5>

      <table>
        <tr>
          <td>文件名</td>
          <td colspan="3"> {{Ord_FileName}}</td>
        </tr>
        <tr>
          <td>成品尺寸(cm)</td>
          <td>{{Det_BoardSiez_H}} * {{Det_BoardSize_W}}</td>
          <td> 板子层数</td>
          <td>{{Det_Layer}}</td>
        </tr>
        <tr>
          <td>板子数量(pcs)(cm)</td>
          <td>{{Det_Num}} </td>
          <td>板子厚度</td>
          <td>{{Det_BoardThickness}}</td>
        </tr>
        <tr>
          <td>阻焊颜色</td>
          <td>{{Det_ZHcolor}}</td>
          <td>字符颜色</td>
          <td>{{Det_ZFcolor}}</td>
        </tr>
        <tr>
          <td> 测试方式</td>
          <td>{{Det_TestMethod}}</td>
          <td>表面处理</td>
          <td>{{Det_SurfaceType}}</td>
        </tr>
        <tr>
          <td> 过孔处理</td>
          <td>过孔盖油</td>
          <td>成品铜厚</td>
          <td></td>
        </tr>
        <tr>
          <td> 合计金额(元)</td>
          <td colspan="3">{{Ord_PriceCheck}}</td>
        </tr>
        <tr>
          <td>附注</td>
          <td colspan="3"></td>
        </tr>
      </table>
      <i>
        附注
        注：1、所有工艺参数以下单为准，备注无效。 2、本着友好的合作机制，甲方委托乙方制作相关产品，为减少相关争议，本着公平，恪守合约的精神制订本合同，本合同为电子档请甲方自行到乙方下单系统下载打印， 乙方不另行提供，在下载合同之前表明，甲方已经接受在乙方下单系统上确认的所有内容！
      </i><br>
      一、支付方式不同，价格不同，最终的价格以你付款的支付方式为准<br>
      二：约定细则<br>
      1: 本加工要求以甲方提供的文件数据为准，若有特殊要求，请给出文字说明，如属资料错误或设计不规范引起的问题，乙方不承担任何责任。<br>
      2: 甲方对乙方加工生产的线路板质量有异议的，应在收货之日起三个月内提出书面异议，逾期则视甲方认可。<br>
      3: 如PCB质量存在问题，不承担乙方生产的电路板货款之外的任何经济赔偿！在订单没有安排工厂生产前可取消，收取10元的工程资料费，如安排到工厂则无法取消!<br>
      4: 飞针或测试架测的PCB，云上初阳承诺电器性能直通率100%，如果全测的PCB发现有开路及短路的问题，则坏一片赔十片，赔偿最高不超出本合约PCB加工货款！<br>
      5: 目测的PCB，云上初阳承诺电器性能直通率98%，如果抽测的PCB发现有开路及短路的问题的不良率超过了2%，则超出的部分坏一片赔十片，赔偿最高不超出本合约PCB加工货款！<br>
      6: 对于其它的质问题，包括但不仅限于如字符、阻焊、外形等，如有质量问题仅赔偿坏板PCB货款的本身！<br>
      7: 赔付的规则如下：<br>
      7.1: 仅限生产过程造成的线路开路，短路，过孔似断非断，过孔不通这四类品质问题，其它原因包括但不仅限于工程资料制作问题引起的开路、短路及各种工程资料问题， 以及字符、阻焊、外观、公差等引起的各类品质问题不在本第7条赔偿细则范围之内<br>
      7.2: 如发现特定品质问题，需第一时间联系我司，不能先自行维修，如不认云上初阳的鉴定结果，则提交给有资质第三方鉴定公司， 第三方鉴定公司暂指定为经中国认监委批准、国内外多个组织认可和授权、专业从事第三方认证的“广州赛宝认证中心”进行认证， 如自修维修如没有办法取证则自行承担不能索赔后果<br>
      7.3: 云上初阳提供的PCB仅为正常环境下的PCB，如PCB在特殊环境下出的问题不在此索赔范围，包括但不仅限于如强酸、强碱、高温、极寒等<br>
      7.4: 赔付的最高货款不超云上初阳系统的总货款，且总货款不得超过1000000元整，单片PCB的上限成本不得高于本身10倍<br>
      7.5: 在特定品质问题中，对于隐患性比较强的过孔似断非断，出现一定比例问题则视为批量性的问题，客有权要求按约定批量性赔偿， 如果本订单超出10片且超出1%的出现过孔不通的问题视为批量性的问题，其它没有出现问题的板则也要进行全额赔偿！<br>
      7.6: 如确认为品质问题，PCB所有权归云上初阳所有，PCB寄给我司后一周内进行赔付给贵司<br>
      7.7: 如本赔付第7条细则没有规定的参考本合约的其它条款，如下单界面与本第7条约相冲突的则以本合约为准，如本合约其它条款与第7条赔付细则相冲突的则以第7条细则为准。<br>
      8: 在订单没有安排工厂生产前可取消，收取10元的工程资料费，如安排到工厂则无法取消!<br>
      9: 云上初阳因生产管理需要，会在所有的电路板上加上客编及内编。如有异议，请下单时提出。如不提出，表示认可，本公司不担任何责任。<br>
      10: 由于线路板加工的不可逆性，如因甲方原因（如资料变更或错误等），甲方须无条件接受我司生产的线路板。<br>
      11: 由于线路板生产工艺的复杂性，需拼板出货的板有可能会存在打叉板（单只报废）现象。如需方不接受打叉板，请在下单备注中提出，如不提出，默认表示认可，本公司不承担任何责任。<br>
      12: 云上初阳品质接受标准以国标二级标准验收，标准中允许成品板中存在有修理板现象（修理板指的是补线，割线，局部补油等）， 如对质量有特殊要求不允许修理板，请在下单时特别提出，如不提出，默认表示认可此标准，本公司不承担任何责任。<br>
      13: 如发生争议，则双方积极沟通协商解决，协商解决不了则可以在乙方所在地法院进行上诉！<br>
      14: 因为商务业务对外承诺会发生变化，如果本条约中没有明确规定，则以宣传承诺为执行依据，如与本合约相冲突的则以本合约为准！<br>
      15: 本协议为电子合同，乙方系统自动生成！<br>
      <br>
      <div class="fon">
        <i class="font">
          供应商： 深圳云上初阳电子商务有限公司<br>
          地址: 深圳市宝安区西乡街道富华社区宝运达物流中心信息大厦801A<br>
          电话: 0755-2308-0620<br>
          签章：<br>
          <img src="../../assets/imges/MTZN52G4OMs.png"
               alt="">
        </i>
      </div>

    </div>
 
    </div>
</template>
<script>
export default {
    data(){
        return{
            Ord_Num:'',//订单编号
               // 支付状态
      Ord_CheckResult: '',
      // 文件名
      Ord_FileName: '',
      // 板子尺寸
      Det_BoardSiez_H: '',
      Det_BoardSize_W: '',
      // 板子层数
      Det_Layer: '',
      // 板子数量
      Det_Num: '',
      // 板子厚度
      Det_BoardThickness: '',
      // 阻焊颜色
      Det_ZHcolor: '',
      // 字符颜色
      Det_ZFcolor: '',
      // 测试方式
      Det_TestMethod: '',
      // 表面处理
      Det_SurfaceType: '',
      // 过孔处理
      Det_PlugHolestyle: '',
      // 总金额
      Ord_PriceCheck: '',
     //合同生成时间
      time: '',
    // 发票编号
    value:''
        }
    },
    created(){
        this.Ord_Num=this.$route.params.Ord_Num
        this.print()
    },
    methods:{
        print(){
            this.$http.post('OrderWebservice.asmx/Print', {
        Ord_Num: this.Ord_Num
      }).then((res)=>{
        let Print1= this.$x2js.xml2js(res.data.d) 
        this.Ord_CheckResult = Print1.NewDataSet.ds[0].Ord_CheckResult
      this.Ord_FileName = Print1.NewDataSet.ds[0].Ord_FileName
      this.Det_BoardSiez_H = Print1.NewDataSet.ds[1].Det_BoardSiez_H
      this.Det_BoardSize_W = Print1.NewDataSet.ds[1].Det_BoardSize_W
      this.Det_Layer = Print1.NewDataSet.ds[1].Det_Layer
      this.Det_Num = Print1.NewDataSet.ds[1].Det_Num
      this.Det_BoardThickness = Print1.NewDataSet.ds[1].Det_BoardThickness
      this.Det_ZHcolor = Print1.NewDataSet.ds[1].Det_ZHcolor
      this.Det_ZFcolor = Print1.NewDataSet.ds[1].Det_ZFcolor
      this.Det_TestMethod = Print1.NewDataSet.ds[1].Det_TestMethod
      this.Det_SurfaceType = Print1.NewDataSet.ds[1].Det_SurfaceType
      this.Det_PlugHolestyle = Print1.NewDataSet.ds[1].Det_PlugHolestyle
      this.Ord_PriceCheck = Print1.NewDataSet.ds[0].Ord_PriceCheck
    // 合同生成时间
      const mydate = new Date()
      this.time = mydate.toLocaleString()

      }).catch((res)=>{
          console.log(res)
      })
        },
        PrintTheContract(){
             var newWin = window.open('') //新打开一个空窗口
      var imageToPrint = document.getElementById('print') //将要被打印的图片
      newWin.document.write(imageToPrint.outerHTML) //将图片添加进新的窗口
      newWin.document.close() //在IE浏览器中使用必须添加这一句
      newWin.focus() //在IE浏览器中使用必须添加这一句
      setTimeout(function() {
        newWin.print() //打印
        newWin.close() //关闭窗口
      }, 100)
        }
        
    }
}
</script>
<style lang="scss" scoped>
i{
    font-style: unset;
}
img {
  width: 200px;
  height: 200px;
  position: relative;
  top: -180px;
  left: 50px;
}
table {
  font-size: 14px;
  width: 800px;
  border-top: 1px solid #999;
  border-left: 1px solid #999;
  border-spacing: 0; /*去掉单元格间隙*/
  text-align: center;
}
table td {
  padding: 10px 30px;

  border-bottom: 1px solid #999;

  border-right: 1px solid #999;
}
.fon {
  width: 400px;
  float: right;
}
.font {
  color: #000;
  text-align: left;
}
i {
  color: crimson;
  font-weight: 400;
  font-size: 14px;
}
h4,
h5 {
  width: 100%;
  margin: 0 auto;
  margin-top: 5px;
}
h4 {
  text-align: center;
  margin-top: 30px;
}
div {
  width: 1000px;
  margin: auto;
  line-height: 30px;
}
.el-button {
  margin-top: 80px;
  background-color: rgb(207, 216, 216);
}
</style>


// WEBPACK FOOTER //
// src/view/home/print.vue